import styled from "styled-components"

export interface StyledCarouselProps {
  no_of_slides: number
  slides_per_view_mobile: number
  slides_per_view_tablet: number
  slides_per_view_desktop: number
  slides_per_view_wide: number
}

export const StyledCarouselWrapper = styled.div`
    width: 100%;
    position: relative;
`

export const StyledCarousel = styled.div`
  width: 100%;
  overflow: hidden;
`

export const StyledSlides = styled.div`
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  scroll-behavior: smooth;
  position: relative;
  display: grid;
  margin-right: -8px;
  scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */

  ::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}

  & > div {
    scroll-snap-align: start;
    height: 100%;
    width: calc(100% - 8px);
    // width: 100%;
    transition: transform 0.5s;
  }
  @media (min-width: ${(props) => props.theme.breakPoints.wide}) {
    grid-template-columns: repeat(
      ${(props) => props.slides_count},
      calc(100% / ${(props) => props.slides_per_view_wide})
    );
  }
  @media (max-width: ${(props) => props.theme.breakPoints.wide}) {
    grid-template-columns: repeat(
      ${(props) => props.slides_count},
      calc(100% / ${(props) => props.slides_per_view_desktop})
    );
  }
  @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    grid-template-columns: repeat(
      ${(props) => props.slides_count},
      calc(100% / ${(props) => props.slides_per_view_tablet})
    );
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    grid-template-columns: repeat(
      ${(props) => props.slides_count},
      calc(100% / ${(props) => props.slides_per_view_mobile})
    );
  }
`

export const StyledButton = styled.button<StyledCarouselProps>`
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
  border: 0;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  transition: 0.2s;
  justify-content: center;
  cursor: pointer;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: 36px;
    height: 44px;
    & i {
      svg {
        max-width: 14px;
        min-width: 14px;
        max-height: 14px;
        min-height: 14px;
      }
    }
  }
  &:nth-of-type(2) {
    left: auto;
    transform: translate(50%, -50%);
    right: 0px;
  }
  & svg {
    color: ${(props) => props.theme.colors.darkGrey};
  }

  ${(props) =>
    props.show_button
      ? `
    opacity: 1;
  `
      : `
    opacity: 0;
  `}
`
